/**
 * @generated SignedSource<<e28c28666f946b4e9ca306ebdaa149ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarAdminComponent_store$data = {
  readonly publicTeams: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TeamSelectList_Team">;
  }>;
  readonly " $fragmentType": "CalendarAdminComponent_store";
};
export type CalendarAdminComponent_store$key = {
  readonly " $data"?: CalendarAdminComponent_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarAdminComponent_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarAdminComponent_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "publicTeams",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamSelectList_Team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "1a5d5017b56879df51b15ea4bdcbbb88";

export default node;
